module.exports = __webpack_public_path__ + "static/media/remnant-of-a-glorious-past.13008ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/remnant-of-a-glorious-past.jpg
// module id = 317
// module chunks = 0